import styled from 'styled-components';
import { colors, IMForm } from '@insurancemenu/imenu-components-lib';
import AttributesSection from 'components/common/rfq/AttributesSection';

export const SaveTemplatesPageContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6rem;
`;

export const SectionStyled = styled.section`
  min-height: 15rem;
  width: 100%;
  position: relative;
  background-color: ${colors.neutral.white};
  border-radius: 1rem;
  margin: 0 auto;
`;

export const SectionTitleStyled = styled.h2`
  font-size: 1.6rem;
  line-height: 2.4rem;
  font-weight: 700;
  letter-spacing: 0.05rem;
  text-transform: uppercase;
  text-align: center;
  padding: 1.5rem 0;
  border-bottom: 0.1rem solid ${colors.neutral[300]};
  margin: 0 0 5rem;
`;

export const StatisticsListStyled = styled.ul`
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  flex-wrap: wrap;
  padding: 0 4rem;
  margin: 0;
`;

export const StatisticsItemStyled = styled.li`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  border-radius: 0.6rem;
  color: ${colors.neutral[900]};
  flex-direction: column;
  padding: 2rem 6rem;
  min-width: 22rem;
  box-sizing: border-box;
  width: 30%;

  &:first-child {
    background: ${colors.blue[100]};
  }

  &:nth-child(2) {
    background: ${colors.green[100]};
  }

  &:nth-child(3) {
    background: ${colors.neutral[100]};
  }
`;

export const StatisticsTitleStyled = styled.p`
  font-size: 1.6rem;
  line-height: 2.4rem;
  letter-spacing: 0.05rem;
  text-transform: uppercase;
  margin: 0;
`;

export const StatisticsValueStyled = styled.span`
  font-size: 2.4rem;
  font-weight: 700;
  line-height: 3.2rem;
  letter-spacing: 0.05rem;
`;

export const PlanAttributesListStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4rem;
  padding: 4rem;
`;

export const IMFormStyled = styled(IMForm)`
  padding: 0 4rem 5rem;
  margin: 0 auto;
  max-width: 85rem;
`;

export const SpinnerBgStyled = styled.div`
  border-radius: 0.6rem;
`;

export const FooterStyled = styled.footer`
  display: flex;
  justify-content: center;
  gap: 1.6rem;
  margin-bottom: 9.6rem;
`;

export const AttributesSectionStyled = styled(AttributesSection)`
  margin-top: 3rem;
  padding: 0;
`;
